import { type FC, type PropsWithChildren, useState } from 'react';

import { type LeagueMyRewardType } from '@/common/types/league';

import { LeagueClaimRewardContext } from './context';
import { LeagueClaimReward } from './LeagueClaimReward';

const LeagueClaimRewardProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [myRewards, setMyRewards] = useState<LeagueMyRewardType[]>([]);
  const [rewardIndex, setRewardIndex] = useState<number>(0);
  const [leagueId, setLeagueId] = useState<string | undefined>();
  const [leagueShortInfo, setLeagueShortInfo] = useState<{
    name: string;
    num: number;
  } | null>(null);

  return (
    <LeagueClaimRewardContext.Provider
      value={{
        setMyRewards,
        isOpen,
        setIsOpen,
        setLeagueId,
        setLeagueShortInfo,
      }}
    >
      {children}
      <LeagueClaimReward
        leagueId={leagueId}
        rewards={myRewards[rewardIndex]}
        setRewardIndex={setRewardIndex}
        rewardsQuantity={myRewards.length}
        isOpen={isOpen}
        leagueShortInfo={leagueShortInfo}
        setIsOpen={setIsOpen}
        rewardIndex={rewardIndex}
        setMyRewards={setMyRewards}
      />
    </LeagueClaimRewardContext.Provider>
  );
};

export { LeagueClaimRewardProvider };
